import React from 'react';

import {ReactComponent as AllGamesIcon} from "../images/icons/allGames.svg";
import {ReactComponent as Favorite} from "../images/icons/favorite.svg";

import img1 from '../images/cards/jackpot/card-1.jpg'
import img2 from '../images/cards/jackpot/card-2.jpg'
import img3 from '../images/cards/jackpot/card-3.jpg'
import img4 from '../images/cards/jackpot/card-4.jpg'
import img5 from '../images/cards/jackpot/card-5.jpg'
import img6 from '../images/cards/jackpot/card-6.jpg'
import img7 from '../images/cards/jackpot/card-7.jpg'
import img8 from '../images/cards/jackpot/card-8.jpg'
import img9 from '../images/cards/jackpot/card-9.jpg'
import img10 from '../images/cards/jackpot/card-10.jpg'
import img11 from '../images/cards/jackpot/card-11.jpg'
import img12 from '../images/cards/jackpot/card-12.jpg'


export const JackpotDB = [
  {
    image: img1,
    name: 'Jackpot Games',
    
  },
  {
    image: img2,
    name: 'Jackpot Games',
    
  },
  {
    image: img3,
    name: 'Jackpot Games',
    
  },
  {
    image: img4,
    name: 'Jackpot Games',
    
  },
  {
    image: img5,
    name: 'Jackpot Games',
    
  },
  {
    image: img6,
    name: 'Jackpot Games',
    
  },
  {
    image: img7,
    name: 'Jackpot Games',
    
  },
  {
    image: img8,
    name: 'Jackpot Games',
    
  },

  {
    image: img9,
    name: 'Jackpot Games',
    
  },
  {
    image: img10,
    name: 'Jackpot Games',
    
  },
  {
    image: img11,
    name: 'Jackpot Games',
    
  },
  {
    image: img12,
    name: 'Jackpot Games',
    
  }
]
